export const UserFilter = new function() {

    
    this.init = () => {
        let userSection = document.querySelector('.sn-section--14');

        if (userSection) {

            let filters = document.querySelectorAll(".sn-user-filter-btn");
            let users = document.getElementsByClassName("sn-user");
            
            filters.forEach(function(filter) {
                filter.addEventListener("click", function() {
                    // Remove active class from all filters
                    filters.forEach(function(f) {
                    f.classList.remove("active");
                    });
                    
                    // Add active class to the clicked filter
                    this.classList.add("active");
                    
                    // Apply filter to show/hide users
                    let filterType = this.id;
                    filterUsers(filterType);
                });
            });
            
            
            // Activate the "Sanitas" filter by default
            document.getElementById("sanitas-filter").click();
            
            function filterUsers(filterType) {
                for (let i = 0; i < users.length; i++) {
                    let user = users[i];
                    let userFilters = user.classList;
                    
                    if (filterType === "sanitas-filter" && userFilters.contains("sanitas")) {
                    user.style.display = "block";
                    } else if (filterType === "bupa-filter" && userFilters.contains("bupa")) {
                    user.style.display = "block";
                    } else {
                    user.style.display = "none";
                    }
                }
            }

        };
    }
    
};